

































































import { Vue, Component, Prop } from 'vue-property-decorator'
import * as mainTypes from '@/store/content/types'
import * as types from '@/store/account/types'
import Course from '@/store/models/course.ts'
import { Action, Getter } from 'vuex-class'
import VDropdown from '@/components/VDropdown.vue'
import VButton from '@/components/VButton.vue'
import VModal from '@/components/VModal.vue'

@Component({ components: { VButton, VDropdown, VModal } })
export default class ChangeGradeModal extends Vue {
  @Action('changeGradeAndCoursesAndBooks', { namespace: 'account' }) changeGradeAndCourses!: types.ChangeGradeAndCoursesAction
  @Getter('userInfo', { namespace: 'account' }) getUserInfo!: types.AccountState
  @Getter('gradesTree', { namespace: 'content' }) gradesTree!: mainTypes.GradesTree
  @Prop() private show!: boolean;

  private modalStep = 1
  private selectedGrade: mainTypes.Grade = { grade: '', year: '-1', courses: new Array<Course>() }
  private changingGrade = false
  private checkedCourses: Course[] = []
  private selectedBooks: { [key: number]: number } = {}
  private checkedBooks = []

  private created () {
    this.initChangeGrade()
  }

  private initChangeGrade () {
    this.selectedGrade = this.gradesTree.find((grade) => {
      return grade.grade === this.getUserInfo.grade && grade.year === this.getUserInfo.year
    }) || { grade: '', year: '-1', courses: new Array<Course>() }
    this.modalStep = 1
  }

  private get gradeCourses () {
    return this.checkedCourses.filter((course) => this.selectedGrade.courses.map(course => course.id).includes(course.id))
  }

  private changeGrade () {
    this.changingGrade = true
    this.changeGradeAndCourses({
      grade: this.selectedGrade.grade,
      year: this.selectedGrade.year,
      courses: this.gradeCourses.map((course) => course.id),
      books: this.checkedBooks
    }).then(() => {
      this.$emit('update:show', false)
    }).finally(() => {
      this.changingGrade = false
    })
  }
}
